/**
 * base64.ts
 *
 * Chunked base64 encoding of binary buffers. Encoding in 0x8000-byte chunks
 * keeps the spread into `String.fromCodePoint` under the engine's argument-count
 * limit, so it works for large documents/presentations where spreading the whole
 * buffer at once would throw a RangeError.
 */

const CHUNK = 0x8000;

/** Encode raw bytes as a base64 string. */
export function bytesToBase64(bytes: Uint8Array): string {
  let binary = "";
  for (let i = 0; i < bytes.length; i += CHUNK) {
    binary += String.fromCodePoint(...bytes.subarray(i, i + CHUNK));
  }
  return btoa(binary);
}

/** Encode an ArrayBuffer as a base64 string. */
export function bufferToBase64(buf: ArrayBuffer): string {
  return bytesToBase64(new Uint8Array(buf));
}
